import { SetsConfigService } from 'src/services/SetsConfigService';

export const mutateSetsConfig = (
    {
        accessToken,
        productKey,
        config,
        signal,
    }: App.SetsConfigs.UpdateMutationVariables,
): Promise<Models.IngestConfigApi.SetsConfigs.ProductSetsConfig> => SetsConfigService.updateSetsConfig(
    accessToken,
    productKey,
    config,
    signal,
);
